mutation UpdateSettingsPostalShipping($input: PostalShippingInput!) {
  updatePostalShippingSettings(input: $input) {
    lead {
      postalShipping {
        type
        allGuides
        activeLandingpages
      }
    }
  }
}
